{
  "familyId": "TAA-ONT-LV-MV",
  "questions": [
    {
      "id": "TAA-ONT-LV-MV-001",
      "familyId": "TAA-ONT-LV-MV",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_lv_mv",
      "questionType": "multiple_choice",
      "question": "Wat is het lijdend voorwerp in deze zin? 'Ik geef mijn zus een cadeau.'",
      "context": null,
      "options": ["een cadeau", "mijn zus", "Ik", "geef"],
      "correctAnswer": 0,
      "pedagogy": { "dok": 2 },
      "misconceptionTags": ["taa.lv-mv-verwarring", "taa.onderwerp-als-lv", "taa.pv-als-zinsdeel"],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Lijdend voorwerp vinden", "content": "Het lijdend voorwerp is wat direct de handeling ondergaat. Stel de vraag: onderwerp + persoonsvorm + WIE of WAT?", "icon": "lightbulb" }, "showWhen": "wrong" }
      ],
      "conceptId": "direct_object_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Persoonsvorm → 'geef'. Onderwerp → 'Ik' (wie geeft?). 'Ik geef WIE of WAT?' → een cadeau. Let op: 'mijn zus' is het meewerkend voorwerp (aan wie geef ik?).",
        "solutionSteps": ["Persoonsvorm → 'geef'", "Onderwerp → 'Ik' (wie geeft?)", "'Ik geef WIE of WAT?' → een cadeau", "'Mijn zus' = meewerkend voorwerp (aan wie?)"],
        "distractorExplanations": {
          "0": "Goed! 'Een cadeau' is het lijdend voorwerp: ik geef WIE of WAT? → een cadeau.",
          "1": "Je dacht waarschijnlijk dat 'mijn zus' het lijdend voorwerp is. Maar 'mijn zus' is het meewerkend voorwerp (AAN WIE geef ik?). Onthoud: LV = wie/wat, MV = aan wie/voor wie.",
          "2": "Je dacht waarschijnlijk dat het onderwerp het lijdend voorwerp is. Maar 'Ik' is het onderwerp (wie geeft?). Onthoud: het lijdend voorwerp is wat gegeven wordt.",
          "3": "Je dacht waarschijnlijk dat de persoonsvorm het lijdend voorwerp is. Maar 'geef' is de persoonsvorm (het werkwoord). Onthoud: het lijdend voorwerp is wat gegeven wordt: een cadeau."
        }
      }
    },
    {
      "id": "TAA-ONT-LV-MV-002",
      "familyId": "TAA-ONT-LV-MV",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_lv_mv",
      "questionType": "multiple_choice",
      "question": "Wat is het meewerkend voorwerp in deze zin? 'De leraar geeft de leerling een boek.'",
      "context": null,
      "options": ["de leerling", "een boek", "De leraar", "geeft"],
      "correctAnswer": 0,
      "pedagogy": { "dok": 2 },
      "misconceptionTags": ["taa.lv-mv-verwarring", "taa.onderwerp-als-mv", "taa.pv-als-zinsdeel"],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Meewerkend voorwerp vinden", "content": "Het meewerkend voorwerp is aan wie of voor wie de handeling wordt gedaan. Stel de vraag: onderwerp + persoonsvorm + AAN WIE?", "icon": "lightbulb" }, "showWhen": "wrong" }
      ],
      "conceptId": "indirect_object_basic",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Persoonsvorm → 'geeft'. Onderwerp → 'De leraar'. 'De leraar geeft AAN WIE?' → de leerling. Controleer: 'een boek' is het lijdend voorwerp (WAT geeft de leraar?).",
        "solutionSteps": ["Persoonsvorm → 'geeft'", "Onderwerp → 'De leraar'", "'De leraar geeft AAN WIE?' → de leerling", "'Een boek' = lijdend voorwerp (WAT?)"],
        "distractorExplanations": {
          "0": "Goed! 'De leerling' is het meewerkend voorwerp: de leraar geeft AAN WIE? → de leerling.",
          "1": "Je dacht waarschijnlijk dat 'een boek' het meewerkend voorwerp is. Maar 'een boek' is het lijdend voorwerp (WAT wordt gegeven). Onthoud: MV = aan wie, LV = wie/wat.",
          "2": "Je dacht waarschijnlijk dat het onderwerp het meewerkend voorwerp is. Maar 'De leraar' is het onderwerp (wie geeft?). Onthoud: het meewerkend voorwerp is aan wie de leraar geeft.",
          "3": "Je dacht waarschijnlijk dat de persoonsvorm een zinsdeel is. Maar 'geeft' is de persoonsvorm (het werkwoord). Onthoud: het meewerkend voorwerp is: de leerling."
        }
      }
    },
    {
      "id": "TAA-ONT-LV-MV-003",
      "familyId": "TAA-ONT-LV-MV",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_lv_mv",
      "questionType": "multiple_choice",
      "question": "Wat is het lijdend voorwerp in: 'De kok bakt een taart voor het feest.'?",
      "context": null,
      "options": ["een taart", "De kok", "bakt", "het feest"],
      "correctAnswer": 0,
      "pedagogy": { "dok": 2 },
      "misconceptionTags": ["taa.onderwerp-als-lv", "taa.pv-als-zinsdeel", "taa.bwb-als-lv"],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Lijdend voorwerp", "content": "Het lijdend voorwerp ondergaat de handeling direct. Stel de vraag: 'De kok bakt WIE of WAT?' → een taart.", "icon": "lightbulb" }, "showWhen": "wrong" }
      ],
      "conceptId": "direct_object_baking",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Persoonsvorm → 'bakt'. Onderwerp → 'De kok'. 'De kok bakt WIE of WAT?' → een taart = lijdend voorwerp. 'Voor het feest' beantwoordt de vraag 'waarvoor?' → bijwoordelijke bepaling van doel.",
        "solutionSteps": ["Persoonsvorm → 'bakt'", "Onderwerp → 'De kok'", "'De kok bakt WIE of WAT?' → een taart", "'Voor het feest' = bijwoordelijke bepaling (waarvoor?)"],
        "distractorExplanations": {
          "0": "Goed! 'Een taart' is het lijdend voorwerp: de kok bakt WIE of WAT? → een taart.",
          "1": "Je dacht waarschijnlijk dat het onderwerp het lijdend voorwerp is. Maar 'De kok' is het onderwerp (wie bakt?). Onthoud: het lijdend voorwerp is wat gebakken wordt.",
          "2": "Je dacht waarschijnlijk dat de persoonsvorm een zinsdeel is. Maar 'bakt' is de persoonsvorm (het werkwoord). Onthoud: het lijdend voorwerp is: een taart.",
          "3": "Je dacht waarschijnlijk dat 'het feest' het lijdend voorwerp is. Maar 'het feest' is onderdeel van 'voor het feest' (bijwoordelijke bepaling: waarvoor?). Onthoud: het lijdend voorwerp is: een taart."
        }
      }
    },
    {
      "id": "TAA-ONT-LV-MV-004",
      "familyId": "TAA-ONT-LV-MV",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_lv_mv",
      "questionType": "multiple_choice",
      "question": "Wat is het meewerkend voorwerp in: 'Mama leest haar dochter een verhaaltje voor.'?",
      "context": null,
      "options": ["haar dochter", "een verhaaltje", "Mama", "leest"],
      "correctAnswer": 0,
      "pedagogy": { "dok": 2 },
      "misconceptionTags": ["taa.lv-mv-verwarring", "taa.onderwerp-als-mv", "taa.pv-als-zinsdeel"],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Meewerkend voorwerp herkennen", "content": "Het meewerkend voorwerp is aan wie of voor wie iets wordt gedaan. 'Mama leest AAN WIE voor?' → haar dochter.", "icon": "lightbulb" }, "showWhen": "wrong" }
      ],
      "conceptId": "indirect_object_reading",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Persoonsvorm → 'leest'. Onderwerp → 'Mama'. 'Mama leest AAN WIE voor?' → haar dochter = meewerkend voorwerp. 'Mama leest WAT voor?' → een verhaaltje = lijdend voorwerp. Let op: 'voorlezen' is een scheidbaar werkwoord (leest ... voor).",
        "solutionSteps": ["Persoonsvorm → 'leest'", "Onderwerp → 'Mama'", "'Mama leest AAN WIE voor?' → haar dochter (MV)", "'Mama leest WAT voor?' → een verhaaltje (LV)"],
        "distractorExplanations": {
          "0": "Goed! 'Haar dochter' is het meewerkend voorwerp: mama leest AAN WIE voor? → haar dochter.",
          "1": "Je dacht waarschijnlijk dat 'een verhaaltje' het meewerkend voorwerp is. Maar 'een verhaaltje' is het lijdend voorwerp (WAT leest mama voor?). Onthoud: MV = aan wie, LV = wie/wat.",
          "2": "Je dacht waarschijnlijk dat het onderwerp het meewerkend voorwerp is. Maar 'Mama' is het onderwerp (wie leest voor?). Onthoud: het meewerkend voorwerp is aan wie mama voorleest.",
          "3": "Je dacht waarschijnlijk dat de persoonsvorm een zinsdeel is. Maar 'leest' is de persoonsvorm. Onthoud: het meewerkend voorwerp is: haar dochter."
        }
      }
    },
    {
      "id": "TAA-ONT-LV-MV-005",
      "familyId": "TAA-ONT-LV-MV",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_lv_mv",
      "questionType": "multiple_choice",
      "question": "Welke zin bevat een meewerkend voorwerp?",
      "context": null,
      "options": ["Jan stuurt zijn vriend een bericht.", "De zon schijnt helder.", "Wij fietsen naar school.", "Het regent al de hele dag."],
      "correctAnswer": 0,
      "pedagogy": { "dok": 2 },
      "misconceptionTags": ["taa.bwb-als-mv", "taa.mv-herkenning-zonder-overdracht"],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Meewerkend voorwerp herkennen", "content": "Een meewerkend voorwerp beantwoordt 'aan wie?' of 'voor wie?'. Alleen bij werkwoorden als geven, sturen, vertellen, lenen staat vaak een meewerkend voorwerp.", "icon": "lightbulb" }, "showWhen": "wrong" }
      ],
      "conceptId": "indirect_object_recognition",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Jan stuurt AAN WIE?' → zijn vriend = meewerkend voorwerp. 'Jan stuurt WAT?' → een bericht = lijdend voorwerp. De andere zinnen hebben geen 'overdracht'-werkwoord, dus geen meewerkend voorwerp.",
        "solutionSteps": ["Zoek een 'overdracht'-werkwoord: sturen ✓", "'Jan stuurt AAN WIE?' → zijn vriend (MV)", "'Jan stuurt WAT?' → een bericht (LV)", "Andere zinnen: geen overdracht → geen MV"],
        "distractorExplanations": {
          "0": "Goed! 'Zijn vriend' is het meewerkend voorwerp: Jan stuurt AAN WIE? → zijn vriend.",
          "1": "Je dacht waarschijnlijk dat deze zin een meewerkend voorwerp heeft. Maar 'De zon schijnt helder' heeft geen lijdend of meewerkend voorwerp. Onthoud: 'helder' is een bijwoord (hoe schijnt de zon?).",
          "2": "Je dacht waarschijnlijk dat 'naar school' een meewerkend voorwerp is. Maar 'naar school' is een bijwoordelijke bepaling van richting (waarheen?). Onthoud: een MV beantwoordt 'aan wie/voor wie'.",
          "3": "Je dacht waarschijnlijk dat deze zin een meewerkend voorwerp heeft. Maar 'Het regent al de hele dag' heeft geen meewerkend voorwerp. Onthoud: 'al de hele dag' is een bijwoordelijke bepaling van tijd."
        }
      }
    },
    {
      "id": "TAA-ONT-LV-MV-006",
      "familyId": "TAA-ONT-LV-MV",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_lv_mv",
      "questionType": "sentence_parser",
      "question": "Wijs het onderwerp (OND), het lijdend voorwerp (LV) en het meewerkend voorwerp (MV) aan.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentenceParser": {
          "sentence": "Opa vertelt de kinderen een verhaal.",
          "words": ["Opa", "vertelt", "de kinderen", "een verhaal"],
          "labels": ["OND", "LV", "MV"],
          "colors": {
            "OND": "#3B82F6",
            "LV": "#F59E0B",
            "MV": "#8B5CF6"
          },
          "correctAssignments": {
            "0": "OND",
            "2": "MV",
            "3": "LV"
          }
        }
      },
      "conceptId": "lv_mv_parser",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "LV en MV toewijzen",
            "content": "Wie vertelt? → Opa (OND). Opa vertelt WAT? → een verhaal (LV). Opa vertelt AAN WIE? → de kinderen (MV). Het lijdend voorwerp is WAT, het meewerkend voorwerp is AAN WIE.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": { "dok": 2 },
      "misconceptionTags": ["taa.lv-mv-verwarring"],
      "feedback": {
        "explanationText": "Opa (OND) vertelt de kinderen (MV) een verhaal (LV). Wie vertelt? → Opa. Wat vertelt opa? → een verhaal (LV). Aan wie vertelt opa? → de kinderen (MV).",
        "solutionSteps": [
          "Wie vertelt? → Opa = onderwerp (OND)",
          "Opa vertelt WAT? → een verhaal = lijdend voorwerp (LV)",
          "Opa vertelt AAN WIE? → de kinderen = meewerkend voorwerp (MV)"
        ]
      }
    },
    {
      "id": "TAA-ONT-LV-MV-007",
      "familyId": "TAA-ONT-LV-MV",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "zinsontleding",
      "subSkill": "ontl_lv_mv",
      "questionType": "true_false_series",
      "question": "Beoordeel of de onderstreepte woorden correct benoemd zijn.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "'De juf geeft Tom een boek.' — 'Tom' is het meewerkend voorwerp.", "correct": true },
          { "text": "'Ik maak mijn huiswerk.' — 'mijn huiswerk' is het meewerkend voorwerp.", "correct": false },
          { "text": "'Zij stuurt haar vriendin een kaart.' — 'een kaart' is het lijdend voorwerp.", "correct": true },
          { "text": "'De hond eet zijn brokjes.' — 'zijn brokjes' is het meewerkend voorwerp.", "correct": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "LV vs MV onderscheiden",
            "content": "LV = wie/wat? (ondergaat de handeling). MV = aan wie/voor wie? (ontvangt iets). 'Mijn huiswerk' en 'zijn brokjes' ondergaan de handeling → LV, niet MV.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lv_mv_beoordelen",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "misconceptionTags": ["taa.lv-mv-verwarring"],
      "feedback": {
        "explanationText": "Tom = MV (aan wie geeft de juf?) ✓. Mijn huiswerk = LV, niet MV (wat maak ik?) ✗. Een kaart = LV (wat stuurt zij?) ✓. Zijn brokjes = LV, niet MV (wat eet de hond?) ✗.",
        "solutionSteps": [
          "Tom: de juf geeft AAN WIE? → Tom = MV ✓",
          "Mijn huiswerk: ik maak WAT? → mijn huiswerk = LV (niet MV) ✗",
          "Een kaart: zij stuurt WAT? → een kaart = LV ✓",
          "Zijn brokjes: de hond eet WAT? → zijn brokjes = LV (niet MV) ✗"
        ]
      }
    }
  ]
}